import { c as _c } from "react/compiler-runtime";
import Text from '../text';
export type BreadcrumbItemProps = {
  as?: React.ElementType;
  href?: string;
  children: string | React.ReactNode;
};
const BreadcrumbItem = t0 => {
  const $ = _c(5);
  const {
    as: t1,
    href,
    children
  } = t0;
  const Component = t1 === undefined ? "a" : t1;
  const hasLink = !!href;
  let t2;
  if ($[0] !== Component || $[1] !== children || $[2] !== hasLink || $[3] !== href) {
    t2 = hasLink ? <li><Component href={href}><Text color="tertiary" variant="body-2">{children}</Text></Component></li> : <li><Text variant="label-2">{children}</Text></li>;
    $[0] = Component;
    $[1] = children;
    $[2] = hasLink;
    $[3] = href;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default BreadcrumbItem;